export default "__VITE_ASSET__16be15a2__"